import { render, staticRenderFns } from "./PublicationsForm.vue?vue&type=template&id=41410f6a&scoped=true"
import script from "./PublicationsForm.vue?vue&type=script&lang=js"
export * from "./PublicationsForm.vue?vue&type=script&lang=js"
import style0 from "./PublicationsForm.vue?vue&type=style&index=0&id=41410f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41410f6a",
  null
  
)

export default component.exports